import { SET_COMPARE_ADS, UPDATE_COMPARE_ADS, UPDATE_ACCORDION_INDEX, UPDATE_AD_SELECTED_INDEX } from '../constants/ActionTypes';

const initialState = {
  compareAds: {
    ads: {},
    loaded: false,
  },
  moreInfoIndexes: {},
  adInfoIndexes: {},
};
const run = {};

run[UPDATE_COMPARE_ADS] = (state, action) => {
  return Object.assign({}, state, {
    compareAds: {
      ads: {
        adsToCompareFirst: state.compareAds.ads.adsToCompareFirst.map(a => {
          if (a.ad_id === action.ad.ad_id) {
            return action.ad;
          }
          return a;
        }),
        adsToCompareSecond: state.compareAds.ads.adsToCompareSecond.map(a => {
          if (a.ad_id === action.ad.ad_id) {
            return action.ad;
          }
          return a;
        }),
      },
      loaded: true,
    },
  });
};

run[UPDATE_ACCORDION_INDEX] = (state, action) => {
  return Object.assign({}, state, {
    moreInfoIndexes: {
      [action.moreInfoName]: action.newIndex,
    },
  });
};

run[UPDATE_AD_SELECTED_INDEX] = (state, action) => {
  return Object.assign({}, state, {
    adInfoIndexes: {
      [action.moreInfoName]: action.newIndex,
    },
  });
};

run[SET_COMPARE_ADS] = (state, action) => {
  return Object.assign({}, state, {
    compareAds: {
      ads: action.ads,
      loaded: true,
    },
  });
};

const adReducer = (state = initialState, action) => {
  if (action.type in run) {
    return run[action.type](state, action);
  }

  return state;
};

export default adReducer;



// WEBPACK FOOTER //
// ./src/reducers/ad.js